/**
 * Anthropic-format tool schemas for the Apiboo AI assistant.
 *
 * CANONICAL COPY. Ported verbatim from the retired backend AI proxy's
 * BackendPheonix.Ai.Tools (+ Tools.Tasks / Db / Docs / Terminal), which the
 * server kept only as a schema source once the proxy retired (BYO key,
 * 16.08.2026). Edits happen HERE from now on; the server modules are not
 * consulted at runtime by anything anymore. The lists live in ./toolSchemas/*
 * (one file per area, 22.10.2026); this file keeps the order.
 *
 * The Anthropic wire shape ({ name, description, input_schema }) stays the
 * internal lingua franca on purpose: AIChatPanel already produces and consumes
 * Anthropic-shaped message history, and the OpenAI/Gemini adapters translate
 * FROM this shape rather than every surface learning three formats.
 *
 * Order matters for Anthropic prompt caching: the array is stable, and the
 * anthropic adapter marks the LAST tool with a cache breakpoint. Any
 * dynamically-appended tools must be concatenated AFTER this list so they
 * never invalidate the cached prefix (same invariant the server carried).
 */

import { COLLECTIONS_TOOLS } from './toolSchemas/collectionsTools';
import { TASKS_TOOLS } from './toolSchemas/tasksTools';
import { DB_TOOLS, DOCS_TOOLS, TERMINAL_TOOLS } from './toolSchemas/dbDocsTerminalTools';
import {
  CODEGEN_TOOLS,
  DISCOVERY_TOOLS,
  FTP_TOOLS,
  GIT_TOOLS,
  IMPORT_TOOLS,
  MOCK_TOOLS,
  STREAM_TOOLS,
  WORKSPACE_TOOLS,
} from './toolSchemas/workspaceTools';

const ALL_TOOLS = [
  ...COLLECTIONS_TOOLS,
  ...TASKS_TOOLS,
  ...DB_TOOLS,
  ...DOCS_TOOLS,
  ...TERMINAL_TOOLS,
  ...WORKSPACE_TOOLS,
  ...IMPORT_TOOLS,
  ...CODEGEN_TOOLS,
  ...MOCK_TOOLS,
  ...GIT_TOOLS,
  ...FTP_TOOLS,
  ...STREAM_TOOLS,
  ...DISCOVERY_TOOLS,
];

/** The full, ordered tool list (Anthropic shape). Callers must not mutate it. */
export function listToolSchemas() {
  return ALL_TOOLS;
}
